import { ISODate } from "../core/types/entities";
import dayjs from "dayjs";

/**
 * Safely creates a Date object from various input types
 * @param dateValue - The date value to convert (string, Date, null, or undefined)
 * @returns A valid Date object or null if the input is invalid
 */
export const createSafeDate = (dateValue: string | Date | null | undefined): Date | null => {
  if (!dateValue) return null;

  const date = new Date(dateValue);
  // Check if the date is valid
  if (isNaN(date.getTime())) {
    console.warn("Invalid date value provided:", dateValue);
    return null;
  }

  return date;
};

/**
 * Safely converts a Date object to ISO date string (YYYY-MM-DD format)
 * @param date - The date to convert
 * @returns ISO date string or undefined if the date is invalid
 */
export const getSafeISODate = (date: Date | null | undefined): ISODate | undefined => {
  if (!date) return undefined;

  const _date = dayjs(date);
  // Check if the date is valid
  if (!_date.isValid()) {
    console.warn("Invalid date provided to getSafeISODate:", date);
    return undefined;
  }

  return _date.format("YYYY-MM-DD") as ISODate;
};

/**
 * Safely converts a Date object to ISO string
 * @param date - The date to convert
 * @returns ISO string or undefined if the date is invalid
 */
export const getSafeISOString = (date: Date | null | undefined): string | undefined => {
  if (!date) return undefined;

  // Check if the date is valid before calling toISOString
  if (isNaN(date.getTime())) {
    console.warn("Invalid date provided to getSafeISOString:", date);
    return undefined;
  }

  return date.toISOString();
};
